export interface AuthUser {
  id: number;
  username: string;
  role: "admin" | "user";
}

async function parseJson(res: Response): Promise<any> {
  return res.json().catch(() => ({}));
}

export async function fetchMe(): Promise<AuthUser | null> {
  const res = await fetch("/api/auth/me", { credentials: "same-origin" });
  if (!res.ok) return null;
  const data = await parseJson(res);
  return data.user ?? null;
}

export async function login(username: string, password: string): Promise<AuthUser> {
  const res = await fetch("/api/auth/login", {
    method: "POST",
    credentials: "same-origin",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ username, password }),
  });
  const data = await parseJson(res);
  if (!res.ok) throw new Error(data.error || "登录失败");
  return data.user as AuthUser;
}

export async function logout(): Promise<void> {
  await fetch("/api/auth/logout", { method: "POST", credentials: "same-origin" });
}

export async function updateMyPassword(currentPassword: string, password: string): Promise<AuthUser> {
  const res = await fetch("/api/auth/me", {
    method: "PUT",
    credentials: "same-origin",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ currentPassword, password }),
  });
  const data = await parseJson(res);
  if (!res.ok) throw new Error(data.error || "保存失败");
  return data.user as AuthUser;
}
